export const isValidDate = (date?: Date): boolean =>
  date !== undefined && !isNaN(date.getTime());
